import "./Background_module.css";
const Background_module = {
    background: "background__3fd35fb908dd30db"
};
export { Background_module as default };
